<template>
  <div class="tab contentWrapper" v-if="isActive && show">
    <slot v-bind="{ id: id, name: name, active: isActive }"></slot>
  </div>
</template>

<script>
import utils from "@/utils"

export default {
  name: "Tab",
  components: {
  },
	props: {
		name: {
			type:		String,
			required:	true
		},
		active: {
			type:	Boolean,
			default:false
		},
		id: {
			type:	String,
			default:null
		},
		show: {
			type:	Boolean,
			default:true
		},
    icon: {
		  type: String,
      default: null
    }
	},
	created() {
		this.$parent.tabs.push( this );
	},
	data() {
		return {
			id_: this.id !== null ? this.id : utils.uniqueHashGen()
		};
	},
	computed: {
		isActive() {
			return this.$parent.active === this;
		}
	},
	watch: {
		show() {
			if ( this.isActive ) this.$parent.tabChange();
		}
	}
};
</script>

<style scoped>
  .contentWrapper {
    width: 100%;
    height: calc( 100% - 0.3em ); /* dont ask me why, seems to be cause is Loader component */
  }
</style>
